import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/pages.css';

const GAMES = [
  {
    key: 'splendor',
    name: 'Splendor',
    tagline: '璀璨宝石',
    description: '收集宝石、购买发展卡、招揽贵族，率先累积 15 分声望即可获胜。',
    icon: '💎',
    route: '/lobby',
    accent: '#4caf50',
  },
  {
    key: 'gizmos',
    name: 'Gizmos',
    tagline: '发明工坊',
    description: '采集能量球、建造发明、触发连锁反应，打造你的发明引擎。',
    icon: '⚙️',
    route: '/gizmos/lobby',
    accent: '#5c6bc0',
  },
];

export default function HomePage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="home-page">
      <div className="lobby-header">
        <h2>🎲 游戏中心</h2>
        <div className="lobby-header-right">
          <span className="username-badge">👤 {user?.username}</span>
          <button className="btn-secondary" onClick={logout}>退出登录</button>
        </div>
      </div>

      <p className="home-subtitle">选择一个游戏开始游玩</p>

      <div className="home-game-grid">
        {GAMES.map(g => (
          <div
            key={g.key}
            className="home-game-card"
            style={{ '--accent': g.accent }}
            onClick={() => navigate(g.route)}
          >
            <div className="home-game-icon">{g.icon}</div>
            <div className="home-game-name">{g.name}</div>
            <div className="home-game-tagline">{g.tagline}</div>
            <p className="home-game-desc">{g.description}</p>
            <button className="btn-primary home-game-btn">进入大厅</button>
          </div>
        ))}
      </div>
    </div>
  );
}
